const formCategory = [
    {"id": "1", "value": "Compliance Observation Forms", "label": "Compliance Observation Forms"},
    {"id": "2", "value": "Learner Support", "label": "Learner Support"},
    {"id": "3", "value": "AE Mgmt", "label": "AE Mgmt"},
    {"id": "4", "value": "Course Mgmt", "label": "Course Mgmt"},
    {"id": "5", "value": "Organisational Outcomes", "label": "Organisational Outcomes"},
    {"id": "6", "value": "Review Monitoring Tools", "label": "Review Monitoring Tools"}
]

const formCategory_All = [
    {"id": "0", "value": "All", "label": "All"},
    {"id": "1", "value": "Compliance Observation Forms", "label": "Compliance Observation Forms"},
    {"id": "2", "value": "Learner Support", "label": "Learner Support"},
    {"id": "3", "value": "AE Mgmt", "label": "AE Mgmt"},
    {"id": "4", "value": "Course Mgmt", "label": "Course Mgmt"},
    {"id": "5", "value": "Organisational Outcomes", "label": "Organisational Outcomes"},
    {"id": "6", "value": "Review Monitoring Tools", "label": "Review Monitoring Tools"}
]

const staticForm1 = '68628572861e8d321f78eead';
const staticForm2 = '6863e9d263caab644f74a3f5';

const appraisalForm = '6866798c27211befdaf1d253';
const consolidatedForm = '68c1953a560083d9f24e9892';
const trainerCompetencies = '68628572861e8d321f78eead';
const assessorCompetencies = '6863e9d263caab644f74a3f5';


export {
    formCategory,
    formCategory_All,
    staticForm1,
    staticForm2,
    appraisalForm,
    consolidatedForm,
    trainerCompetencies,
    assessorCompetencies
}